import type React from 'react';
import { FormField, FormHelp, Label } from '@zillow/constellation-10';

import type { Section } from '../../..//models';
import { LATE_RENT } from '../../../constants';
import CurrencyInput from '../../Widgets/CurrencyInput';

type Props = {
  section: Section;
  setSectionValues: (keyValuePairs: object) => void;
};

export default function LateRent_v2({ section, setSectionValues }: Props): JSX.Element {
  function onLateFeeChange(event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>): void {
    const { value } = event.currentTarget;

    setSectionValues({
      [LATE_RENT.FIELD_NAME.FEE_AMOUNT]: value,
    });
  }

  return (
    <FormField
      required
      error={section.getField(LATE_RENT.FIELD_NAME.FEE_AMOUNT).hasError}
      label={<Label>What is the fee for late rent?</Label>}
      control={
        <CurrencyInput
          value={section.getFieldValue(LATE_RENT.FIELD_NAME.FEE_AMOUNT)}
          onChange={onLateFeeChange}
          onBlur={onLateFeeChange}
          error={section.getField(LATE_RENT.FIELD_NAME.FEE_AMOUNT).hasError}
          endAdornment="flat fee"
        />
      }
      description={
        section.getField(LATE_RENT.FIELD_NAME.FEE_AMOUNT).hasError && (
          <FormHelp>{section.getField(LATE_RENT.FIELD_NAME.FEE_AMOUNT).getErrorMessage()}</FormHelp>
        )
      }
    />
  );
}

LateRent_v2.description = 'Late rent without days late, only fee assessed.';
